import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DoughnutChart = ({ data }) => {
    const chartData = {
        labels: ['Male', 'Female'],
        datasets: [
            {
                data: [data.totalMale, data.totalFemale],
                backgroundColor: ['#36A2EB', '#FF6384'],
                borderWidth: 1,
            }
        ]
    };

    const options = {
        cutout: '70%',
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.label}: ${context.parsed}`
                }
            }
        }
    };

    return (
        <div style={{ position: 'relative', width: 300, height: 300 }}>
            <Doughnut data={chartData} options={options} />
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                fontSize: '18px',
                fontWeight: 'bold'
            }}>
                {data.totalUser} <br />
                Users
            </div>
        </div>
    );
};

export default DoughnutChart;